<app-modal #modal [backdropStatic]="true">

  <span title class="title">
    {{"Review & Accept Our Terms of Use"|translate}}
  </span>
  <div body class="body">
    <p>
      <span>
        {{"Please take a moment to review our"|translate}}&nbsp;
      </span>
      <a class="btn btn-link" (click)="handleClickLink()" [routerLink]="sharedService.getUrl_TermsAndConditionsPage()">
        {{"Terms of Use"|translate}}
      </a>
      <span>
        &nbsp;{{'and tap "Accept" to continue using the webapp'|translate}}&nbsp;
      </span>
      <span>.</span>
    </p>
  </div>

  <div footer class="footer">
    <button class="btn btn-primary" (click)="handleAccept()">
      {{"Accept"|translate}}
    </button>
  </div>

</app-modal>
